<template>
  <div class="input-container"
       :class="{
         'filled': isFilled,
         'focused': isFocused
       }">
    <span class="placeholder">{{ label }}</span>
    <textarea @focus="onFocus"
              @blur="onBlur"
              @input="$emit('input', $event.target.value)"
              :disabled="disabled"
              :value="value">
    </textarea>
  </div>
</template>

<script>
  export default {
      props: ['value', 'label', 'disabled'],
      data() {
          return {
              isFilled: false,
              isFocused: false
          }
      },
      methods: {
          onFocus() {
              this.isFilled = true
              this.isFocused = true
      },
      onBlur() {
        this.isFocused = false
        if (this.value === '' || this.value ===  null)
          this.isFilled = false
      }
    },
    mounted() {
      this.onFocus()
      this.onBlur()
    },
    watch: {
      value() {
        this.onFocus()
        this.onBlur()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-container {
    width: 100%;
    position: relative;

    .placeholder {
      position: absolute;
      top: 20px;
      color: #686868;
      z-index: 1;
      font-size: 14px;
      transition: all .2s ease;
    }

    &.filled .placeholder {
      top: 0;
      font-size: 13px;
      color: #afafaf;
    }

    &.focused .placeholder {
      color: #3498db;
    }

    textarea {
      position: relative;
      z-index: 1;
        background: transparent;
        margin: 18px 0 0 0;
        padding: 6px 0 8px 0;
        width: 100%;
        border: 0;
        border-bottom: 1px solid #d7dce9;
        font-size: 14px;
        resize: vertical;
        min-height: 80px;
        transition: border-bottom-color .2s ease;

        &[disabled] {
            color: #aaaaaa;
        }
    }

    &.focused textarea {
      border-color: #3498db;
    }
  }
</style>
